export enum CoresWhiteLabelKeplerWeberEnum {
    COR_PRIMARIA = '#F58220',
    COR_PRIMARIA_OPACIDADE = 'rgba(246, 130, 32, 0.1)',
    COR_SECUNDARIA = '#F58220',
    COR_TERCIARIA = '#231F20',
}
